import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { usePageTitle } from 'utils/pageTitle';
import DashboardLayout from 'pages/_rd_dashboard/DashboardLayout';


import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';
import { fetchPortfolio } from 'reducers/portfolioReducer';
import { setAllNotificationsByPortfolioId } from 'reducers/portfolioSettingsReducer';

import Spinner from 'components/Spinner';
import Paginator from 'components/Paginator';

import './EmailSettings.css';

const EmailSettings = (props) => {
	usePageTitle('Email Settings');
	const dispatch = useDispatch();
	let {
		userId,
		portfolio,
		isLoading,
		currentPage,
		totalPages,
	} = useSelector(state => ({
		userId: state.user.userData?.id,
		portfolio: state.portfolio.portfolioData?.data || [],
		isLoading: state.portfolio.isLoading,
		currentPage: state.portfolio.portfolioData?.current_page,
		totalPages: state.portfolio.portfolioData?.last_page,
	}));

	let [unsubState, setUnsubState] = useState({});


	const openNotificationModal = (portfolioId, property) => {
		dispatch(openModal(MODAL_TYPES.PROPERTY_NOTIFICATION_MODAL, { portfolioId, property }));
	}


	const onDisable = (portfolioItemId) => {
		let state = { ...unsubState };
		state[portfolioItemId] = true;
		setUnsubState(state);
		dispatch(setAllNotificationsByPortfolioId(portfolioItemId, false));
	};

	useEffect(() => {
		dispatch(fetchPortfolio(userId));
	}, [userId, dispatch]);


	return (
		<DashboardLayout>
			<div className="dashboard-portfolio v3-scope">
				<div className="dashboard-section">
					<div className="dashboard-section-header">
						<h1><i className={'bi bi-buildings me-3'} />Email Settings</h1>
					</div>
					<div className="dashboard-section-body">
						{isLoading ? <Spinner /> :
							<div className="pb-4">
								<div className="dashboard-table-wrapper">
									<table className="table table-striped table-rounded">
										<thead><tr>
											<th>Property</th>
											{/*<th />*/}
											<th className="unsubscribe-cell" />
										</tr></thead>
										<tbody>
											{(!portfolio || !portfolio.length) && (
												<tr><td colSpan={5}>You are not subscribed to any property emails</td></tr>
											)}
											{portfolio?.map((item) => (
												<tr key={item.id}>
													<td className="dashboard-table-property-address-cell">
														{item.property?.address || '-'}
													</td>
													{/*<td>
														<div className="form-group form-check" key={`${item.id}`}>
															<input
																type="checkbox"
																className="form-check-input"
																id={`${item.id}`}
																value={unsubState[item.id] || false}
																checked={unsubState[item.id] || false}
																onChange={(ev) => handleToggle(ev, item.id)}
															/>
															<label className="form-check-label" htmlFor={`${item.id}`}>Receive alerts about this property</label>
														</div>
													</td>*/}
													<td className="dashboard-table-buttons-cell unsubscribe-cell">
														{unsubState[item.id] ? <span className="unsubbed-text mx-3">You have been unsubscribed</span> : 
															<button className="btn btn-danger btn-sm me-3" onClick={() => onDisable(item.id)}>Unsubscribe</button>
														}
														<button className="btn btn-primary btn-sm" onClick={() => openNotificationModal(item.id, item.property)}>Notifications</button>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
								<Paginator
									currentPage={currentPage}
									totalPages={totalPages}
									setPage={(pageNum) => dispatch(fetchPortfolio(userId, 'address|asc', pageNum, 10))}
								/>
							</div>
						}
					</div>
				</div>
			</div>
		</DashboardLayout>
	);	


}

export default EmailSettings;
